/* La casa de los gadgets — interacciones compartidas */
(function () {
  if (window.__lcgInit) return;
  window.__lcgInit = true;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Reveal al hacer scroll, con stagger por data-lcg-stagger */
  function initReveals() {
    var items = document.querySelectorAll('.lcg-reveal:not(.is-in)');
    if (!items.length) return;

    if (reduced || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.1 }
    );

    document.querySelectorAll('[data-lcg-stagger]').forEach(function (group) {
      Array.prototype.forEach.call(group.children, function (child, i) {
        if (child.classList.contains('lcg-reveal')) {
          child.style.setProperty('--lcg-delay', Math.min(i * 70, 420) + 'ms');
        }
      });
    });

    items.forEach(function (el) { io.observe(el); });
  }

  /* Barra de compra sticky: aparece después de pasar el hero */
  function initStickyBar() {
    var bar = document.querySelector('[data-lcg-sticky]');
    if (!bar) return;

    var sentinel = document.querySelector('[data-vb-block]') || document.body.firstElementChild;
    if (!sentinel || !('IntersectionObserver' in window)) {
      bar.classList.add('is-visible');
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        var visible = !entries[0].isIntersecting;
        bar.classList.toggle('is-visible', visible);
        document.body.classList.toggle('lcg-has-sticky', visible);
      },
      { threshold: 0 }
    );
    io.observe(sentinel);
  }

  function init() {
    initReveals();
    initStickyBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
